import React from 'react'
import { pure } from 'recompose'
import { ExternalLink } from 'components'
import { IMAGE_PATH, SEATOW_MOBILE_APP_URL } from 'config'

function MobileAppPromo() {
  return (
    <ExternalLink
      className="mobile-app-promo"
      href={SEATOW_MOBILE_APP_URL}
      showIcon={false}
      aria-label="Download the Sea Tow App"
    >
      <img src={IMAGE_PATH.MOBILE_APP_PROMO} alt="" />
    </ExternalLink>
  )
}

export default pure(MobileAppPromo)
